import { EventsBySportIdRequest } from "../../Dependencies";
/**
 * Get market event id in FullBetSlip format
 * @param {Event} e Event, from which to retrieve id
 * @param {Market} m Market, from which to retrieve id
 * @return {string} Market event id
 */
export const getMarketEventID = (e, m) => e.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() ||
    e.type === EventsBySportIdRequest.EventTypesEnum.AntePostRace.toString() ||
    e.type === EventsBySportIdRequest.EventTypesEnum.DayOfEventRace.toString()
    ? "0"
    : m.eventId || "0";
//# sourceMappingURL=getMarketEventID.js.map